export default __webpack_public_path__ + "a687380656c6c252d256e3029a455466.png";